module.exports = __webpack_public_path__ + "static/media/Terms and Conditions.68df4acd.pdf";